import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrBioIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M13.71 6.4085C13.8142 6.51201 14.0226 6.61553 14.2309 6.61553C14.4393 6.61553 14.6476 6.51201 14.7518 6.4085C15.0644 6.09797 15.0644 5.68392 14.7518 5.37338L10.5846 1.2329C10.2721 0.922366 9.85534 0.922366 9.5428 1.2329C9.23026 1.54344 9.23026 1.95749 9.5428 2.26802L1.83344 10.0314C1.31254 10.549 1 11.2736 1 12.1017C1 12.8262 1.31254 13.5508 1.83344 14.1719C2.35435 14.793 3.08361 15 3.91705 15C4.7505 15 5.37558 14.6895 6.00066 14.1719L13.71 6.4085ZM4.85468 13.0333C4.33378 13.5508 3.39615 13.5508 2.87525 13.0333C2.56271 12.7227 2.45853 12.4122 2.45853 11.9982C2.45853 11.5841 2.56271 11.2736 2.87525 10.963L5.7923 8.0647H9.85534L4.85468 13.0333ZM11.2097 6.71904H7.14665L10.5846 3.30314L12.564 5.26987L11.2097 6.71904ZM14.5435 10.8595L13.6058 9.51386C13.5017 9.30684 13.2933 9.20333 12.9808 9.20333C12.7724 9.20333 12.564 9.30684 12.3557 9.51386L11.418 10.8595C10.6888 11.7911 10.793 12.9298 11.5222 13.6543C11.939 14.0684 12.4599 14.2754 12.9808 14.2754C13.5017 14.2754 14.0226 14.0684 14.4393 13.6543C15.2727 12.8262 15.0644 11.5841 14.5435 10.8595ZM13.5017 12.6192C13.3975 12.7227 13.2933 12.8262 13.0849 12.8262C12.8766 12.8262 12.7724 12.7227 12.564 12.6192C12.2515 12.3087 12.564 11.7911 12.564 11.6876L12.9808 11.1701L13.3975 11.6876C13.5017 11.8946 13.71 12.4122 13.5017 12.6192Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrBioIconComponent;
